import {mapDatasetResponse} from '@/helpers/helper';

const state = {
  appointment: null,
  list:[],
  patientEpisodeId: null,
  patientLocationId: null,
  nonClinicalAppointmentCount: 0,
  getNonClinicalAppointmentsRequest: null
}

const actions = {
  setAppointment ({ commit }, appointment) {
    commit('setAppointment', appointment)
    return true
  },
  setAppointmentsList ({ commit }, list) {
    commit('setAppointmentsList', list)
    return true
  },
  setPatientEpisodeId({ commit }, episodeId) {
    commit('setPatientEpisodeId', episodeId)
    return true
  },
  setPatientLocationId({ commit }, locationId) {
    commit('setPatientLocationId', locationId)
    return true
  },
  setNonClinicalAppointmentCount({ commit }, count) {
    commit('setNonClinicalAppointmentCount', count)
    return true
  },
  getNonClinicalAppointments ({ state, dispatch, commit, getters, rootState, rootGetters }, {gridOptions, gridFilter, onlyCurrentPractice, withDocumentAttached = true}) {
    const url = onlyCurrentPractice ? `/practitioners/${ rootGetters['app/currentUserId'] }/datasets/appointments` :
      `/practitioners/${ rootGetters['app/currentUserId'] }/datasets/referred-appointments`

    if (state.getNonClinicalAppointmentsRequest) {
      state.getNonClinicalAppointmentsRequest.abort();
      commit('setGetNonClinicalAppointmentsRequest', null)
    }

    return new Promise((resolve, reject) => {
      // @ts-ignore
      const request = (this as any)._vm.$_rest.get(url, {
        appointmentStatuses: ['N'],
        filter: gridFilter || {},
        sorting: {columns: gridOptions.sortBy || 'id', desc: gridOptions.sortDesc || true},
        limit: gridOptions.itemsPerPage || 1,
        offset: ((gridOptions.page || 1) - 1) * gridOptions.itemsPerPage || 1,
        secondaryPractitionerTypeCodes: ['N'],
        withDocumentAttached: withDocumentAttached
      }, response => {
        commit('setNonClinicalAppointmentCount', response.meta.rowsNumber)
        resolve(response)
      }, error => {
        reject()
      })

      commit('setGetNonClinicalAppointmentsRequest', request)
    })
  },
}

const mutations = {
  setAppointment (state, appointment) {
    state.appointment = appointment
  },
  setAppointmentsList (state, list) {
    state.list = list
  },
  shiftAppointmentsList (state) {
    state.list.shift()
  },
  setPatientEpisodeId (state, episodeId) {
    state.patientEpisodeId = episodeId
  },
  setPatientLocationId (state, locationId) {
    state.patientLocationId = locationId
  },
  setNonClinicalAppointmentCount(state, count) {
    state.nonClinicalAppointmentCount = count
  },
  setGetNonClinicalAppointmentsRequest(state, request) {
    state.getNonClinicalAppointmentsRequest = request
  }
}

const getters = {
  appointment (state) {
    return state.appointment
  },
  list (state) {
    return state.list
  },
  patientFullName (state) {
    return [state.appointment.patient.firstName, state.appointment.patient.middleName, state.appointment.patient.lastName].filter(el => el && el.trim()).join(' ')
  },
  patientEpisodeId (state) {
    return state.patientEpisodeId
  },
  patientLocationId (state) {
    return state.patientLocationId
  },
  nonClinicalAppointmentCount (state) {
    return state.nonClinicalAppointmentCount
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
